import React, { useState, useEffect, useContext } from 'react';
import { PublicContext } from "../PublicContext";
import dayjs from 'dayjs';
import Holidays from 'date-holidays';
import { List, Card, Space, Anchor, Radio, Button, Modal } from "antd";
import './DateTimeSelector.css';
const { Link } = Anchor;
export default function OrderDateTimeSelector({ visible, setVisible }) {
    const { stores, storeHours, deliveryOrPickUp, setOrderScheduleTime, orderScheduleDate, setOrderScheduleDate } = useContext(PublicContext);
    //const deliveryOrPickUp = sessionStorage.getItem("deliveryOrPickUp");
    const [selectedStore] = useState(JSON.parse(sessionStorage.getItem("selectedStore")).storeCode);
    const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [selectedTime, setSelectedTime] = useState(null);
    const [availableDates, setAvailableDates] = useState([]);
    const [availableTimeOptions, setAvailableTimeOptions] = useState([]);
    const selectedStoreCode = JSON.parse(sessionStorage.getItem('selectedStore')).storeCode;
    const [selectedTimeOption, setSelectedTimeOption] = useState(1);

    const onSelectedTimeOptionChange = (e: RadioChangeEvent) => {
        //console.log('radio checked', e.target.value);
        setSelectedTimeOption(e.target.value);
    };

    useEffect(() => {
        const fetchAvailableDates = () => {
            const currentDate = dayjs();
            const endDate = currentDate.add(14, 'day');

            // Get the selected store data from session storage
            const selectedStore = JSON.parse(sessionStorage.getItem('selectedStore'));
            const selectedStoreCode = selectedStore.storeCode;

            // Generate available dates for the next 14 days
            const dates = [];
            for (let date = currentDate; date.isBefore(endDate); date = date.add(1, 'day')) {
                const formattedDate = date.format("YYYY-MM-DD");
                const selectedDay = date.format("dddd"); // Day of the week (e.g., "Monday", "Tuesday")

                // Check if store has hours for this day
                const hasStoreHours = storeHours
                    .filter(sh => sh.storeCode === selectedStoreCode)
                    .some(sh => sh.day === selectedDay);

                // If the store has hours and it's not a closed date, add to available dates
                //if (hasStoreHours && !isClosed) {
                    dates.push(formattedDate);
                //}
            }

            setAvailableDates(dates);
        };

        fetchAvailableDates();
    }, [selectedStore, storeHours]);

    useEffect(() => {
        const fetchAvailableTimes = () => {
            if (!selectedDate) return;

            // Check if the selected date is a Canadian statutory holiday
            let holidays = new Holidays();
            holidays.init('CA');
            holidays.getHolidays(dayjs(selectedDate).year());
            const isHoliday = holidays.isHoliday(dayjs(selectedDate));

            const selectedClassification = deliveryOrPickUp === 'delivery' ? 'Delivery' : 'Pickup';
            const selectedDay = dayjs(selectedDate).format("dddd");

            // Get CloseDates from selectedStore, assuming it's stored as JSON
            const selectedStore = JSON.parse(sessionStorage.getItem('selectedStore'));
            const selectedStoreCode = selectedStore.storeCode;
            let store = stores.find(store => store.storeCode === selectedStore.storeCode);
            let closeDates = [];
            if (store && store.closeDates) {
                closeDates = JSON.parse(store.closeDates);
            }

            // Check if the date is in the CloseDates
            const isClosed = closeDates.some(closeDate => dayjs(closeDate).isSame(selectedDate, 'day'));

            // Filter store hours for the selected store and selected date
            let selectedStoreHours;
            if (isHoliday) {
                selectedStoreHours = storeHours
                    .filter(sh => sh.storeCode === selectedStoreCode)
                    .find(sh => sh.day === "Sunday" && sh.classification === selectedClassification);
            } else {
                selectedStoreHours = storeHours
                    .filter(sh => sh.storeCode === selectedStoreCode)
                    .find(sh => sh.day === selectedDay && sh.classification === selectedClassification);
            }

            if (selectedStoreHours && !isClosed) {
                let availableTimes = generateTimeRanges(selectedStoreHours.startTime, selectedStoreHours.endTime);

                const currentTime = dayjs();
                const oneHourLater = currentTime.add(1, 'hour');
                const thirtyMinutesLater = currentTime.add(30, 'minute');

                if (dayjs(selectedDate).isSame(currentTime, 'day')) {
                    if (deliveryOrPickUp === "delivery") {
                        availableTimes = availableTimes.filter(time =>
                            dayjs(`${selectedDate} ${time.value}`, "YYYY-MM-DD HH:mm").isAfter(oneHourLater)
                        );
                    } else if (deliveryOrPickUp === "pickup") {
                        availableTimes = availableTimes.filter(time =>
                            dayjs(`${selectedDate} ${time.value}`, "YYYY-MM-DD HH:mm").isAfter(thirtyMinutesLater)
                        );
                    }
                }

                setAvailableTimeOptions(availableTimes);
            } else {
                console.log("not available");
                setAvailableTimeOptions([]);
            }
        };

        fetchAvailableTimes();
    }, [selectedStore, storeHours, selectedDate, deliveryOrPickUp]);

    const generateTimeRanges = (startTime, endTime) => {
        const start = dayjs(startTime, "YYYY-MM-DDTHH:mm:ss");
        const end = dayjs(endTime, "YYYY-MM-DDTHH:mm:ss");
        const increment = 15;
        let currentTime = start;
        const times = [];

        while (currentTime.isBefore(end)) {
            times.push({
                value: currentTime.format("HH:mm"),
                label: `${currentTime.format("h:mm A")} - ${currentTime.add(30, 'minute').format("h:mm A")}`
            });
            currentTime = currentTime.add(increment, "minute");
        }

        return times;
    };

    const handleDateOptionClick = (date) => {
        setSelectedDate(date); // Set selected date
    };

    // Variables to track dragging
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    // Event handler for mouse/touch down
    const handleDown = (event) => {
        isDragging = true;
        startX = event.type === "mousedown" ? event.pageX : event.touches[0].clientX;
        scrollLeft = event.currentTarget.scrollLeft;
        // Ensure the beginning of the flex container starts at the beginning of the parent div
        event.currentTarget.scrollLeft = 0;
    };

    // Event handler for mouse/touch move
    const handleMove = (event) => {
        if (!isDragging) return;
        const x = event.type === "mousemove" ? event.pageX : event.touches[0].clientX;
        const walk = x - startX;
        event.currentTarget.scrollLeft = scrollLeft - walk;
    };

    // Event handler for mouse/touch up
    const handleUp = () => {
        isDragging = false;
    };

    const handleSelectTimeConfirm = () => {
        setOrderScheduleTime(selectedTime);
        sessionStorage.setItem("scheduleTime", selectedTime);
        if (selectedTime === "" || selectedTime === "now") {
            setOrderScheduleDate(dayjs().format("MMM-DD"));
            sessionStorage.setItem("scheduleDate", dayjs().format("MMM-DD"));
        }
        else {
            setOrderScheduleDate(dayjs(selectedDate).format("MMM-DD"));
            sessionStorage.setItem("scheduleDate", dayjs(selectedDate).format("MMM-DD"));
        }
        
        setVisible(false)
    }

    return (
        <Modal
            title="Schedule Order"
            visible={visible}
            onCancel={() => setVisible(false)}
            footer={[
                <Button key="back" className="btn-cancel" onClick={() => setVisible(false)}>
                    Cancel
                </Button>,
                <Button key="submit" className="btn-primary" type="primary" onClick={handleSelectTimeConfirm}>
                    Confirm
                </Button>
            ]}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    overflow: "hidden",
                    maxWidth: "100%",
                    userSelect: "none"
                }}
                onMouseDown={handleDown}
                onMouseMove={handleMove}
                onMouseUp={handleUp}
                onMouseLeave={handleUp}
                onTouchStart={handleDown}
                onTouchMove={handleMove}
                onTouchEnd={handleUp}
                onTouchCancel={handleUp}
                onWheel={(event) => {
                    event.currentTarget.scrollLeft += event.deltaY;
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexWrap: "nowrap",
                        padding: "8px 0",
                        cursor: "grab",
                        overflowX: "auto",
                        WebkitOverflowScrolling: "touch",
                        msOverflowStyle: "none",
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                    }}
                >
                    {availableDates.map((date, index) => (
                        <div
                            key={date}
                            style={{ padding: "0 16px", cursor: "pointer", textAlign: 'center', borderBottom: selectedDate === date ? "2px solid #1890ff" : "none" }}
                            onClick={() => handleDateOptionClick(date)}
                        >
                            {dayjs(date).format("ddd MM/DD")}
                        </div>
                    ))}
                </div>
            </div>
            <Space direction="vertical" style={{ marginTop: 5 }}>
                {availableTimeOptions.length > 0 ? (
                    <div>
                    <Radio.Group onChange={onSelectedTimeOptionChange} value={selectedTimeOption} defaultValue="now">>
                        {/*<Radio*/}
                        {/*    value='now'*/}
                        {/*    key='timeOptionNow'*/}
                        {/*    hoverable="true"*/}
                        {/*    onClick={() => setSelectedTime('now')}*/}
                        {/*    style={{*/}
                        {/*        //width: '50%',*/}
                        {/*        height: 43,*/}
                        {/*        textAlign: 'center',*/}
                        {/*        padding: 10,*/}
                        {/*        marginBottom: 5, // Space between radios*/}
                        {/*        borderRadius: 5, // Rounded border*/}
                        {/*        border: selectedTimeOption === 'now' ? '1px solid #1890ff' : '1px solid #d9d9d9', // Border color*/}
                        {/*        backgroundColor: selectedTimeOption === 'now' ? '#f0f5ff' : 'white', // Background color*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    Now*/}
                        {/*</Radio>*/}
                        <div style={{ maxHeight: 200, overflowY: 'auto', width: '100%', padding: 'auto' }}>
                            {availableTimeOptions.map((time, index) => (
                                <Radio
                                    value={time.value}
                                    key={time.value}
                                    hoverable="true"
                                    onClick={() => setSelectedTime(time.value)}
                                    style={{
                                        //width: '50%',
                                        height: 43,
                                        textAlign: 'center',
                                        padding: 10,
                                        marginBottom: 5, // Space between radios
                                        borderRadius: 5, // Rounded border
                                        border: selectedTimeOption === time.value ? '1px solid #f17fb2' : '1px solid #d9d9d9', // Border color
                                        backgroundColor: selectedTimeOption === time.value ? '#f0f5ff' : 'white', // Background color
                                    }}
                                >
                                    {time.label}
                                </Radio>
                            ))}
                        </div>
                        </Radio.Group>
                    </div>
                        ) : (
                    <div style={{ textAlign: 'center', padding: 20}}>Sorry, no time slot left for today.</div>
                )}
            </Space>
        </Modal>
    );
};
